import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import config from '@iotv/config';
import { pluralReadableTypeName } from '@iotv/core-services';
import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { edgeTypeMatrix } from '@iotv/datamodel-core';
import { ExpressionFunctionType, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { AlertErrors } from '../../../ErrorHandling/ErrorBoundaryFallback';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '../../../types/AppTypes';
import { DefaultStepTypeFolderClickWrapper } from '../../../v2/components/generic/ObjectTree';
import { ObjectTree } from '../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
import { RoutingLabelClickWrapper } from '../clickWrappers/RoutingLabelClickWrapper';
const debug = process.env.REACT_APP_DEBUG && false;
const GROUPER_TYPE = 'Group';
/** @deprecated */
export const entityGroups = [...classDerivedDeviceEnabledTypes, ...Object.keys(config.app.webUI.groupedObjectTypes ?? {})].reduce((det, got) => {
    if (!det.includes(got))
        det.push(got);
    return det;
}, []);
/** @deprecated */
export const getContainedTypeLabelWrapper = (entityTypeId) => (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Entity Groups" }), support: entityTypeId }));
/** Finds supported groups from a User Group, then iteratively goes down their sub groups */
export const VisibleGroupsTree = ({ userGroup, supportedType, nodeEdgeMapper, transactionFunctions, label, uniqueTreeId, domain, contextMenuComponentMap, }) => {
    const nodeFilters = [
        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: supportedType }] },
    ];
    if (domain && domain !== UNCLASSIFIED_DOMAIN)
        nodeFilters.push({ setOperation: LogicalOperatorType.AND, filters: [{ key: 'domain', predicate: ComparisonType.EQUALS, value: domain }] });
    if (domain !== undefined && domain === UNCLASSIFIED_DOMAIN)
        nodeFilters.push({ setOperation: LogicalOperatorType.AND, filters: [{ key: 'domain', predicate: ExpressionFunctionType.NOT_EXISTS }] });
    return (_jsx(TreeItem, { itemId: `${label}-${uniqueTreeId}-visible-${supportedType}-group-${domain}`,
        label: label ?? pluralReadableTypeName(supportedType),
        children: (_jsx(ObjectTree, { contextMenuComponentMap,
            uniqueTreeId,
            nodeEdgeMapper,
            contextObjects: [userGroup],
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: GROUPER_TYPE,
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId,
                        nodeFilters,
                    },
                    thisStepTypeFolderClickWrapper: undefined,
                    renderTypeFolder: false,
                    nextSteps: getSingleTypeRecursivePath({
                        groupObjectType: GROUPER_TYPE,
                        containedObjectType: supportedType,
                        ContainedTypeLabelWrapper: getContainedTypeLabelWrapper(supportedType),
                        ContainedTypeInstanceClickWrapper: RoutingLabelClickWrapper,
                    }),
                },
            ],
            transactionFunctions,
            onTypeFolderClickWrapper: undefined /*CustFolderClickWrapper*/,
            hideTopStep: true,
            maintree_rightclick: true }, `${label}-visible-${supportedType}`)) }, `${label}-visible-${supportedType}-group-${domain}`));
};
/** Wraps Visible Groups tree. TreeProps doesn't provide us the users group, but we need it, so we find it here and pass it along */
export const SpecificVisibleGroupTree = (supportedType, uniqueTreeId, label, domain, contextMenuComponentMap) => {
    return ({ applicationData, transactionFunctions, user }) => {
        const key = `${supportedType}_${label}_${uniqueTreeId}_${domain}`;
        const parents = user ? applicationData.getParentNodes(user) : [];
        const userGroups = parents.filter((n) => n.type === 'Group');
        const userGroup = userGroups.at(0);
        debug && console.log('Specific Visible Group Tree', domain ?? label, supportedType, 'parents & user group', parents, userGroup);
        return (_jsx(AlertErrors, { children: userGroup ? (_jsx(VisibleGroupsTree, { userGroup, supportedType, nodeEdgeMapper: applicationData, transactionFunctions, label, uniqueTreeId, domain, contextMenuComponentMap }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key + '_errors'));
    };
};
